import { PERFORMANCE_DASHBOARD } from 'src/modules/constants';
import { Module, ModulesList } from 'src/modules/types';
import Dashboard from '.';
import DashboardThunk from './thunk';

const module: ModulesList = {
  [PERFORMANCE_DASHBOARD]: {
    path: '/performance/:tab',
    component: Dashboard,
    thunk: DashboardThunk,
  } as Module,
};

export default module;
